import { type Components, type Theme } from "@mui/material/styles";

const borderColor =
  "var(--mui-palette-components-input-outlined-enabledBorder)";

export const typography: Components<Theme>["MuiTypography"] = {
  styleOverrides: {
    root: {
      marginBottom: 0,
    },
  },
  variants: [
    {
      props: { variant: "body3" },
      style: ({ theme }) => ({
        ...theme.typography.body3,
      }),
    },
    {
      props: { variant: "body4" },
      style: ({ theme }) => ({
        ...theme.typography.body4,
      }),
    },
    {
      props: { variant: "buttonSmall" },
      style: ({ theme }) => ({
        ...theme.typography.buttonSmall,
      }),
    },
    {
      props: { variant: "dashedDivider" },
      style: {
        borderBottom: "1px dashed",
        borderColor,
        display: "inline-block",
        width: "100%",
        paddingBottom: 4,
        marginBottom: 8,
      },
    },
    {
      props: { variant: "solidDivider" },
      style: {
        borderBottom: "1px solid",
        borderColor,
        display: "inline-block",
        width: "100%",
        paddingBottom: 4,
        marginBottom: 8,
      },
    },
    {
      props: { variant: "body1DashedDivider" },
      style: ({ theme }) => ({
        ...theme.typography.body1,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px dashed",
        borderColor,
        paddingBottom: 4,
        marginBottom: 8,
      }),
    },
    {
      props: { variant: "body1SolidDivider" },
      style: ({ theme }) => ({
        ...theme.typography.body1,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px solid",
        borderColor,
        paddingBottom: 4,
        marginBottom: 8,
      }),
    },
    {
      props: { variant: "body2DashedDivider" },
      style: ({ theme }) => ({
        ...theme.typography.body2,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px dashed",
        borderColor,
        paddingBottom: 4,
        marginBottom: 4,
      }),
    },
    {
      props: { variant: "body2SolidDivider" },
      style: ({ theme }) => ({
        ...theme.typography.body2,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px solid",
        borderColor,
        marginBottom: 4,
        paddingBottom: 4,
      }),
    },
    {
      props: { variant: "h1DashedDivider" },
      style: ({ theme }) => ({
        ...theme.typography.h1,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px dashed",
        borderColor,
        paddingBottom: 12,
      }),
    },
    {
      props: { variant: "h1SolidDivider" },
      style: ({ theme }) => ({
        ...theme.typography.h1,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px solid",
        borderColor,
        paddingBottom: 12,
      }),
    },
    {
      props: { variant: "h2DashedDivider" },
      style: ({ theme }) => ({
        ...theme.typography.h2,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px dashed",
        borderColor,
        paddingBottom: 12,
      }),
    },
    {
      props: { variant: "h2SolidDivider" },
      style: ({ theme }) => ({
        ...theme.typography.h2,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px solid",
        borderColor,
        paddingBottom: 12,
      }),
    },
    {
      props: { variant: "h3DashedDivider" },
      style: ({ theme }) => ({
        ...theme.typography.h3,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px dashed",
        borderColor,
        paddingBottom: 12,
      }),
    },
    {
      props: { variant: "h3SolidDivider" },
      style: ({ theme }) => ({
        ...theme.typography.h3,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px solid",
        borderColor,
        paddingBottom: 12,
      }),
    },
    {
      props: { variant: "h4DashedDivider" },
      style: ({ theme }) => ({
        ...theme.typography.h4,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px dashed",
        borderColor,
        paddingBottom: 12,
      }),
    },
    {
      props: { variant: "h4SolidDivider" },
      style: ({ theme }) => ({
        ...theme.typography.h4,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px solid",
        borderColor,
        paddingBottom: 12,
      }),
    },
    {
      props: { variant: "h5DashedDivider" },
      style: ({ theme }) => ({
        ...theme.typography.h5,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px dashed",
        borderColor,
        paddingBottom: 12,
      }),
    },
    {
      props: { variant: "h5SolidDivider" },
      style: ({ theme }) => ({
        ...theme.typography.h5,
        display: "inline-block",
        width: "100%",
        borderBottom: "1px solid",
        borderColor,
        paddingBottom: 12,
      }),
    },
    {
      props: { variant: "h6DashedDivider" },
      style: ({ theme }) => ({
        ...theme.typography.h6,
        borderBottom: "1px dashed",
        borderColor,
        paddingBottom: 4,
        display: "flex",
        alignItems: "center",
        gap: 1,
      }),
    },
    {
      props: { variant: "h6SolidDivider" },
      style: ({ theme }) => ({
        ...theme.typography.h6,
        borderBottom: "1px solid",
        borderColor,
        paddingBottom: 4,
        display: "flex",
        alignItems: "center",
        gap: 1,
      }),
    },
    {
      props: { variant: "captionWithBackground" },
      style: ({ theme }) => ({
        ...theme.typography.caption,
        width: "100%",
        padding: "4px",
        borderRadius: "8px",
        color: "text.primary",
      }),
    },
    {
      props: { variant: "sumUpLine" },
      style: ({ theme }) => ({
        ...theme.typography.body2,
        borderTop: "1px solid",
        borderColor: theme.palette.divider,
        paddingTop: 4,
        paddingLeft: 4,
      }),
    },
  ],
};
